import React, { useCallback, ReactElement } from 'react';
import FlexContainer from '../flex-container/flex-container.component';
import Image from '../image/image.component';
import Button from '../button/button.component';
import DeleteIcon from '../../icons/delete-icon';
import FormatService from '../../services/format-service';
import useStylesUploadFileButton from './upload-file-button.styles';
import { DATA_REF_NAME } from '../../constants/system/data-attributes';

const UploadFileButton: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isImage,
    isDisabled,
    withNoOffset,
    withNoPadding,
    uploadFile,
    inputRefs,
    inputRefIndex,
    uploadRef,
    buttonLabel,
    previewImageClassName,
    uploadFileUrl,
    onFileDeleteClick,
  } = props;

  const { classes } = useStylesUploadFileButton();

  const disabledClassName: string | undefined = isDisabled ? classes.uploadFileButtonDisabled : undefined;
  const imageClassName: string | undefined = isImage ? classes.uploadFileButtonImage : undefined;
  const noPaddingClassName: string | undefined = withNoPadding ? classes.uploadFileButtonNoPadding : undefined;
  const containerPreviewImageNoOffsetClassName: string = isImage && withNoOffset && !!uploadFile
    ? classes.uploadFileButtonContainerPreviewImageNoOffset : undefined;

  const onButtonClick: MouseEventHandlerFunction = useCallback((): void => {
    if (!isDisabled) {
      uploadRef.current.click();
    }
  }, [uploadRef, isDisabled]);

  return (
    <Button
      isText
      isDefault
      isDisabled={isDisabled}
      ref={(
        inputRefs ? (inputRef: HTMLButtonElement | null): void => {
          inputRefs.current[inputRefIndex] = inputRef;
        } : null
      )}
      className={FormatService.formatClassNames(
        classes.uploadFileButton, disabledClassName, imageClassName, noPaddingClassName,
      )}
      onClick={onButtonClick}
      {...{
        [DATA_REF_NAME]: inputRefIndex,
      }}
    >
      {
        isImage && (
          <FlexContainer
            className={FormatService.formatClassNames(
              classes.uploadFileButtonContainerPreviewImage, containerPreviewImageNoOffsetClassName,
            )}
          >
            {
              !!uploadFile && (
                <div>
                  <DeleteIcon
                    className={classes.uploadFileButtonIconPreviewImageDelete}
                    onClick={onFileDeleteClick}
                  />
                </div>
              )
            }
            <Image
              isDefault
              text={buttonLabel}
              link={uploadFileUrl}
              className={FormatService.formatClassNames(classes.uploadFileButtonPreviewImage, previewImageClassName)}
            />
          </FlexContainer>
        )
      }
      {
        !isImage && buttonLabel
      }
    </Button>
  );
});

export default UploadFileButton;
